export const Config = {
  BASE_LEARN_API_URL: process.env.REACT_APP_PIPELINE_API,
  BASE_LXP_API_URL: process.env.REACT_APP_PIPELINE_API_LXP,
};

export const getAPIUrlByRole = (role: string) => {
  return role === "learn" ? Config.BASE_LEARN_API_URL : Config.BASE_LXP_API_URL;
};
